import React, { useState, useEffect } from "react";
import { useDispatch } from 'react-redux';
import Payment from 'payment'
import TextField from '@material-ui/core/TextField';
import { updatePayment } from '../../../actions/actionCreators';

const Card = () => {
  const dispatch = useDispatch();
	const [data, setData] = useState({
		credit_card_verification_code: "",
		credit_card_expiration_date: "",
		credit_card_name_on_card: "",
		credit_card_number: ""
	});	

	useEffect(() => {
		Payment.formatCardNumber(document.getElementsByName("credit_card_number"))
    Payment.formatCardExpiry(document.getElementsByName("credit_card_expiration_date"))
		Payment.formatCardCVC(document.getElementsByName("credit_card_verification_code"))
	}, [])
	
	const handleInputChange = (e) => {
		let targetValue = e.target.value
		if(e.target.name === "credit_card_expiration_date"){
			targetValue = targetValue.split(' ').join('');
		}
		setData({
			...data,
			[e.target.name]: targetValue
		});
		let payload = [{ fieldToUpdate: e.target.name, value: targetValue}];
		dispatch(updatePayment(payload));
	};

	return (
		<div className="CardForm">
			<div className="CardNumber">
				<TextField
					type="text"
					name="credit_card_number"
					label="Card number"
					placeholder="Card Number"
					onChange={handleInputChange}
					style={{ width: '100%' }}
					error={!validateNumber()}
				/>
			</div>
			<div className="CardDetails">
				<TextField
					type="text"
					name="credit_card_name_on_card"
					label="Name on card"
					placeholder="Name on card"
					onChange={handleInputChange}
					style={{ width: '40%' }}
					inputProps={{ minLength: 2 }}
				/>
				<TextField
					type="number"
					name="credit_card_verification_code"
					label="CVC"
					placeholder="CVC"
					onChange={handleInputChange}
					style={{ width: '15%' }}
					error={!validateCVC()}
					inputProps={{ maxLength: 4 }}
				/>
				<TextField
					type="text"
					name="credit_card_expiration_date"
					label="Expiration Date"
					placeholder="MM/YYYY"
					onChange={handleInputChange}
					style={{ width: '25%' }}
					error={!validateExpiration()}
				/>
			</div>
		</div>
	);

	function validateNumber(){
		return Payment.fns.validateCardNumber(data.credit_card_number)
	}
	function validateCVC(){
		return Payment.fns.validateCardCVC(data.credit_card_verification_code)
	}
	function validateExpiration(){
		if (!data.credit_card_expiration_date) {return false	}
		const { month, year } = Payment.fns.cardExpiryVal(data.credit_card_expiration_date)
		return Payment.fns.validateCardExpiry(month, year)	
	}

};

export default Card;